import React from "react";
import type { ReactElement, ReactNode, ComponentProps } from "react";

import { VStack, ScrollView, Button } from "native-base";

import BackButton from "pianofunclub-crm/components/Buttons/BackButton";

import { CollapseIcon, ExpandIcon } from "pianofunclub-shared/components/Other/Icons";

type VStackProps = ComponentProps<typeof VStack>;
type ScrollViewProps = ComponentProps<typeof ScrollView>;

interface Props extends VStackProps {
  children?: ReactNode;
  isCollapsed: boolean | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  navigation: any;
  scrollViewProps?: ScrollViewProps;
  setIsCollapsed?: (isCollapsed: boolean | undefined) => void;
}

const SideBar = (props: Props): ReactElement => {
  const { isCollapsed, navigation, scrollViewProps, setIsCollapsed } = props;

  return (
    <ScrollView
      bg="surface.200"
      borderColor="surface.400"
      borderRightWidth={1}
      bottom="0"
      contentContainerStyle={{
        flex: 1,
        flexGrow: 1,
      }}
      left="0"
      position="absolute"
      pt="70"
      showsVerticalScrollIndicator={false}
      top="-70"
      {...scrollViewProps}
    >
      <VStack
        alignItems="center"
        flex={1}
        flexGrow={1}
        p="6"
        space={isCollapsed ? "4" : undefined}
        {...props}
      >
        <BackButton
          onPress={() => navigation.goBack()}
          {...(!isCollapsed
            ? {
                left: "3",
                mt: "70",
                position: "absolute",
                top: "3",
                width: "90",
              }
            : { height: 8, hideText: true, mt: "60", width: 8 })}
        />
        {setIsCollapsed ? (
          <Button
            _hover={{ bg: "transparent", opacity: 0.8 }}
            _pressed={{ bg: "transparent", opacity: 0.7 }}
            colorScheme="muted"
            height={8}
            leftIcon={isCollapsed ? <ExpandIcon size={5} /> : <CollapseIcon size={5} />}
            onPress={() => setIsCollapsed?.(!isCollapsed)}
            variant="ghost"
            width={8}
            {...(!isCollapsed
              ? {
                  mt: "70",
                  position: "absolute",
                  right: "3",
                  top: "3.5",
                }
              : {})}
          />
        ) : null}
        {!isCollapsed ? props.children : null}
      </VStack>
    </ScrollView>
  );
};

export default React.memo(SideBar);
